import React, { useEffect } from 'react'
import { GetServerSideProps } from 'next'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'

import { ConsumerPage } from '../src/model'
import { SignupForm } from '../src/component/Signup/SignupForm'
import { useTranslation } from 'next-i18next'
import { Heading } from '@afterpaytouch/core'
import { TrackPageViewed, useAmplitudeWithEnduringEventProperties } from '../src/integrations/amplitude'
import { BackLink, Head } from '../src/component'
import { Route } from '../src/config/router'
import { useAppRouter, useConsumerEmail } from '../src/state'
import { TrackingEvent } from '../src/model/amplitude'
import { getLayout } from '../src/layouts/WhiteBgLayout'

const I18N_NAMESPACE = ['common', 'signUp']

const Signup: ConsumerPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const consumerEmail = useConsumerEmail()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  useEffect(() => {
    if (!consumerEmail) {
      logEvent(TrackingEvent.CONSUMER_LOST_EMAIL, { consumerEmail })
      router.push(Route.INDEX)
    }
  }, [consumerEmail])

  return (
    <>
      <Head title={t('common:brandName')} />
      <BackLink backTo={Route.INDEX} linkText={t('signUp:backToEmail')} />
      <Heading size='XL' testNameSpace='signup'>
        {t('signUp:heading')}
      </Heading>
      <SignupForm />
      <TrackPageViewed />
    </>
  )
}

Signup.getLayout = getLayout({ fullscreenWhite: true, isHideClose: true, hideTagline: true })

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)
export default Signup
